export const ShareDeviceFooter = () => {
  return (
    <footer>
      <div className="footer">
        <div className="footer__line">
          <div className="footer__inner"></div>
        </div>
      </div>
    </footer>
  );
};
